import type { ViewFieldsFragment } from '@salescore/client-api'
import type { CompiledFormViewConfig, ViewUIFormItem } from '@salescore/core'
import { Form } from 'antd'
import type { ReactElement } from 'react'

import type { SalescoreObjectAbility, ViewAbility } from '../../recoil/view/atoms'
import { useViewUIRecordNodeContext } from './contexts'
import { ViewUIFormComponentC } from './ViewUIComponent'
import { viewUiValidation } from './viewUiValidation'

export const ViewUIFormItemC = ({
  component,
  compiledConfig,
  showError,
  view,
  ability,
}: {
  component: ViewUIFormItem
  compiledConfig: CompiledFormViewConfig
  showError: boolean
  view: ViewFieldsFragment
  ability: ViewAbility & SalescoreObjectAbility
}): ReactElement => {
  const { getValue } = useViewUIRecordNodeContext()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const value = getValue(component.fieldName) as string
  const errors = showError ? viewUiValidation(value, component) : []

  return (
    <Form.Item
      label={<span>{component.label}</span>}
      // name={formListField === undefined ? component.path : [formListField.name, ...component.path]}
      style={{
        marginBottom: 12,
      }}
      // Salesforceで真偽値の場合、必ず必須項目になっている？が、チェックボックスを必須と表示すると見た目的にわかりづらいので一旦表示させない
      // 問題が起きるようであればSalesforce側での根本的な対応を検討
      // rules={isFormItemForCheckbox ? [] : component.validationRules ?? []}
      required={component.required}
    >
      <ViewUIFormComponentC
        component={{ ...component.child, showError }}
        compiledConfig={compiledConfig}
        view={view}
        ability={ability}
      />
      {errors.length > 0 && (
        <div className="text-red-500">
          {errors.map((error, index) => (
            <span key={`${error.message}_${index}`}>{error.message}</span>
          ))}
        </div>
      )}
    </Form.Item>
  )
}
